import {
  ACTION_CREATE_SITE_ALIAS__REQUEST,
  ACTION_CREATE_SITE_ALIAS__SUCCESS,
  ACTION_CREATE_SITE_ALIAS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE_ALIAS__REQUEST:
    case ACTION_CREATE_SITE_ALIAS__SUCCESS:
      return null;

    case ACTION_CREATE_SITE_ALIAS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
